export default "__VITE_ASSET__5dbb7ed3__"